// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","QualityCheckboxes":"ex_a bhm_j bhm_i bhm_bc bhm_r bhm_st","QualityCheckboxes__quality":"ex_b"};